import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../lib/api';

export default function ResourceDetail() {
  const { id } = useParams();
  const [resource, setResource] = useState(null);
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    load();
  }, [id]);

  const load = async () => {
    try {
      const res = await api.get(`/resources/${id}`);
      setResource(res.data?.data);

      const access = await api.get(`/resources/${id}/access`);
      setContent(access.data?.data);
    } catch (err) {
      window.alert(err.response?.data?.message || 'Unable to load resource');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="p-6">Loading resource...</div>;
  if (!resource) return <div className="p-6">Resource not found.</div>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-black text-text">{resource.title}</h1>
        <p className="mt-2 text-muted">{resource.description}</p>
      </div>

      {content?.video_url && (
        <div className="rounded-3xl border border-black/5 bg-white p-5 shadow-sm">
          <h2 className="text-xl font-bold">Video Link</h2>
          <a
            href={content.video_url}
            target="_blank"
            rel="noreferrer"
            className="mt-3 inline-block text-primary underline"
          >
            Watch video
          </a>
        </div>
      )}

      {content?.video_file_url && (
        <div className="rounded-3xl border border-black/5 bg-white p-5 shadow-sm">
          <h2 className="text-xl font-bold">Video File</h2>
          <video controls className="mt-4 w-full rounded-2xl">
            <source src={process.env.REACT_APP_IMAGE_URL_NO_TRAIL + content.video_file_url} />
          </video>
        </div>
      )}

      {content?.download_url && (
        <div className="rounded-3xl border border-black/5 bg-white p-5 shadow-sm">
          <h2 className="text-xl font-bold">Downloadable Content</h2>
          <a
            href={process.env.REACT_APP_IMAGE_URL_NO_TRAIL + content.download_url}
            target="_blank"
            rel="noreferrer"
            className="mt-4 inline-flex rounded-2xl bg-primary px-5 py-3 text-sm font-bold text-white"
          >
            Download file
          </a>
        </div>
      )}
    </div>
  );
}